import React from 'react';
import { MapPin } from 'lucide-react';

const LocationSection = () => {
  const areas = [
    'Tampa',
    'Brandon',
    'Riverview',
    'Clearwater',
    'St. Petersburg',
    'And nearby communities'
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-black to-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center scroll-animate">
          <div className="flex justify-center mb-6">
            <MapPin className="w-16 h-16 text-red-500" />
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Serving <span style={{ color: '#FFD700' }}>Tampa Bay</span> & Surrounding Areas
          </h2>
          <p className="text-xl text-gray-300 mb-8">
            Proudly serving:
          </p>
          <div className="flex flex-wrap justify-center gap-4 max-w-3xl mx-auto">
            {areas.map((area, index) => (
              <span 
                key={index}
                className="px-6 py-3 bg-black/50 border border-red-900/50 rounded-lg text-white font-medium hover:border-red-500 transition-colors"
              >
                {area}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocationSection;
